import { format } from "date-fns";
import EventModal from "./EventModal";
import { PlanningEvent } from "./PlanningEvent";
import { isAfterParsedDate } from "./Planning3";

export const PlanningWeekView = ({
  events,
  timeSlots,
  handleClick,
  handleOpenModal,
  handleCloseModal,
  open,
  highligtedEvent,
  day_view,
  daysOfWeek,
  weekDates,
  height,
  events_colors,
  pack_short_dict,
  simplified_view,
  masterData,
  orgData,
  userData,
  selected_operators,
  onDelete,
  navigateWorkspace,
  workspaceData,
  getYPosition,
  timeToMinutes,
  temporary,
  setTemporary,
}) => {
  return (
    <>
      {day_view === null &&
        daysOfWeek.map((day, day_index) => (
          <div
            key={day_index}
            className="bg-transparent border-l-1 border-shadow_5  flex flex-col  w-1/5  font-light min-h-fit p-1 text-h4 text-black justify-center"
          >
            <div
              className=" gap-1 w-full h-c500 relative "
              style={{
                height: `${height}px`,
              }}
            >
              <div
                className="absolute w-full max-h-full "
                style={{
                  top: "6px",
                }}
              >
                {timeSlots.map((hour, timeindex) => (
                  <div
                    key={timeindex}
                    style={{
                      height: `${height * 0.0772}px`,
                    }}
                    onClick={(e) => {
                      handleClick(e, day_index, null, hour);
                    }}
                    className=" w-full border-t-1   border-shadow_5  select-none relative flex-col hover:border-2 hover:border-wshadow_50 hover:bg-shadow_3 opacity-100 font-light p-2 justify-start"
                  ></div>
                ))}{" "}
              </div>

              {events

                .filter(
                  (event) =>
                    (event.weekdate === day &&
                      (event.frequency || "") !== "daily") ||
                    event.frequency === "daily"
                )
                .filter((event) =>
                  event.exception_dates && event.frequency
                    ? !(event.exception_dates || []).includes(
                        format(weekDates[day_index], "dd/MM/yyyy")
                      )
                    : event.upper_limit_date &&
                        isAfterParsedDate(
                          format(weekDates[day_index], "dd/MM/yyyy"),
                          event.upper_limit_date
                        )
                      ? false
                      : true
                )
                .filter((event) => {
                  const noOperator = selected_operators.includes("no_operator");
                  const allOperators = selected_operators.includes("all");
                  const members = event.members_id ?? [];

                  if (allOperators) return true;
                  if (noOperator && members.length === 0) return true;
                  return members.some((member) =>
                    selected_operators.includes(member)
                  );
                })

                .sort((a, b) => a.start - b.start)

                .map((event, index) => {
                  return (
                    <div
                      key={index}
                      className="absolute w-full "
                      style={{
                        top: `${getYPosition(timeToMinutes(event.startTime))}rem`,
                        zIndex: `${open[event.id] ? "10" : highligtedEvent === event.id ? "5" : "1"}`,
                      }}
                    >
                      <EventModal
                        parsed_date={format(weekDates[day_index], "dd/MM/yyyy")}
                        event={event}
                        setEvent={() => {}}
                        setModalOpen={() => handleCloseModal(event.id)} // Pass close modal handler
                        orgData={orgData}
                        userData={userData}
                        onDelete={(e) => {
                          onDelete(e);
                        }}
                        onUpdate={() => {}}
                        open={open[event.id]}
                        setOpen={(e) => {
                          handleOpenModal(event.id);
                        }}
                        navigateWorkspace={navigateWorkspace}
                        workspaceData={workspaceData}
                        temporary={temporary}
                        setTemporary={setTemporary}
                      >
                        <PlanningEvent
                          event={event}
                          events_colors={events_colors}
                          pack_short_dict={pack_short_dict}
                          highligtedEvent={highligtedEvent}
                          height={height}
                          simplified_view={simplified_view}
                          masterData={masterData}
                        ></PlanningEvent>
                      </EventModal>
                    </div>
                  );
                })}
            </div>
          </div>
        ))}
    </>
  );
};
